import React, { useEffect, useState } from "react";
import { Alert, Button, Divider, InputNumber, Modal } from "antd";
import style from "./index.module.scss";
import { ModalProps } from "antd/es/modal";
import FormList from "./Components/FormList";
import Form, { useForm } from "rc-field-form";
import { AllConfig, OtherRulesItem } from "service/score";

interface AdvancedSettingProps extends ModalProps {
    onCancel: () => void;
    obj: AllConfig;
    setObj: (val: AllConfig) => void;
    onSave: (val: AllConfig) => void;
    rulesConfigObj: { title: string; type: string };
    flag?: string; //当前内置项标志
}

const Index = ({
    onCancel,
    obj,
    setObj,
    onSave,
    rulesConfigObj,
    flag,
    ...props
}: AdvancedSettingProps) => {
    const [form] = useForm();
    const [initVal, setInitVal] = useState<OtherRulesItem[]>([]); //高级设置，成绩区间初始值

    useEffect(() => {
        if (obj.otherRules) {
            setInitVal(obj.otherRules);
        }
        form.setFieldsValue({
            done: obj?.done,
            late: obj?.late,
            leave: obj?.leave
        });
    }, [obj]);

    const onOk = async (data: AllConfig) => {
        // 1.高级设置中判断分数段的成绩是否设置有值，只保存成绩有值的数据。
        // 2.如果分数值未设置，则相对于的符号也置为空。
        const params = data.otherRules
            ?.filter(item => item.grade != null)
            .map(item => ({
                ...item,
                sign1: item.rangeVal1 != null ? item.sign1 : "",
                sign2: item.rangeVal2 != null ? item.sign2 : ""
            }));
        data = { ...data, otherRules: params };
        await setObj({ ...obj, ...data });
        await onSave({ ...obj, ...data });
        onCancel();
    };

    const footer = (
        <div>
            <Button key="back" onClick={() => onCancel()}>
                取消
            </Button>
            <Button key="submit" onClick={form.submit} type="primary">
                确认
            </Button>
        </div>
    );

    return (
        <Modal
            width={610}
            title="高级设置"
            className={style.root}
            onCancel={onCancel}
            centered
            footer={footer}
            {...props}>
            <Form form={form} onFinish={onOk}>
                {flag === "SignInCalculator" && (
                    <>
                        <Alert
                            className={style.tips}
                            message="说明：您可以将学生的签到异常次数，按比例（支持0~1之间的1位小数）折算为出勤次数。在当前设置下，学生出勤次数=(1*正常出勤次数+0
                            *请假次数+0*迟到、早退次数)"
                            type="warning"
                        />
                        <div className={style.wrapper}>
                            <>
                                正常出勤记出勤
                                <Form.Field name="done">
                                    <InputNumber
                                        min={0}
                                        max={1}
                                        className={style.inputNumber}
                                        precision={1}
                                        size="small"
                                    />
                                </Form.Field>
                                次
                            </>
                            <Divider type="vertical" />
                            <>
                                请假记出勤
                                <Form.Field name="leave">
                                    <InputNumber
                                        min={0}
                                        max={1}
                                        className={style.inputNumber}
                                        precision={1}
                                        size="small"
                                    />
                                </Form.Field>
                                次
                            </>
                            <Divider type="vertical" />
                            <>
                                迟到、早退记出勤
                                <Form.Field name="late">
                                    <InputNumber
                                        min={0}
                                        max={1}
                                        className={style.inputNumber}
                                        precision={1}
                                        size="small"
                                    />
                                </Form.Field>
                                次
                            </>
                        </div>
                    </>
                )}
                <FormList
                    data={initVal || []}
                    rulesConfigObj={rulesConfigObj}
                />
            </Form>
        </Modal>
    );
};

export default Index;
